
import { defineComponent, computed, ref, watchEffect } from "@vue/runtime-core";
import { useStore } from "vuex";
import Markdown from "vue3-markdown-it";

export default defineComponent({
  components: {
    Markdown,
  },
  setup() {
    const store = useStore();
    const eventData = computed(() => store.getters["user/eventData"]);
    const bookingCancelationPolicy = ref(null);

    watchEffect(() => {
      if (eventData.value.bookingCancelationPolicy) {
        bookingCancelationPolicy.value =
          eventData.value.bookingCancelationPolicy;
      } else {
        bookingCancelationPolicy.value = null;
      }
    });

    return { eventData, bookingCancelationPolicy };
  },
});
